export function classifyTitle(type: 'none' | 'question') {
  return type === 'question' ? '🟣 Question' : '🔴 None';
}
